import { Navigate } from "react-router-dom"
import { getLoggedInUser } from "../auth/authUtil";

const RequiredAuth = ({ children, userRoles }) => {
    let currentUser = getLoggedInUser();
    if (currentUser) {
        if (userRoles) {
            let isAuth = currentUser?.authorities?.some(item => userRoles.includes(item))
            return isAuth ? children : <Navigate to="/login" />
        } else {
            return children
        }
    } else {
        return <Navigate to="/login" />
    }
}
export default RequiredAuth